import { selectAssetTypeById, selectAssetTypeFieldsById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { AssetTypeFieldsRevisionSettingsDetailView } from "src/views/AssetTypeFieldsRevisionSettingsDetailView/AssetTypeFieldsRevisionSettingsDetailView"
import { assetTypeFieldsRevisionSettingsDetailViewStaticData } from "src/views/AssetTypeFieldsRevisionSettingsDetailView/constants"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/revisions/$assetTypeFieldsId",
)({
	component: AssetTypeFieldsRevisionSettingsDetailView,
	staticData: assetTypeFieldsRevisionSettingsDetailViewStaticData,
	loader: ({ params }) => {
		const assetType = selectAssetTypeById(params.assetTypeId)(appStore.getState())
		const assetTypeFields = selectAssetTypeFieldsById(params.assetTypeFieldsId)(appStore.getState())

		if (!assetType || !assetTypeFields || assetTypeFields.asset_type !== assetType.uuid) throw notFound()
	},
})
